// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2084":"5beea1aa","5134":"0dfc5ddd","6346":"89c0f465"}[chunkId] + ".chunk.css";
};